import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import theme from '../../components/shared/theme';
import { ThemeProvider } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Select from '@material-ui/core/Select';
import DialogActions from '@material-ui/core/DialogActions';
import { MenuItem } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { FormHelperText } from '@material-ui/core';
import api from '../../store/api';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            padding: theme.spacing(0),
            textAlign: 'center',
            color: theme.palette.text.secondary,
        },
        container: {
            backgroundColor: '#00152e',
            backgroundSize: '100%',
            borderRadius: '0',
            width: '100%',
            padding: 60,
        },
        button: {
            width: '100%',
        },
        dialogPaper: {
            minWidth: 500,
            margin: 0,
            borderRadius: 0,
            shadow: 'none',
            backgroundColor: '#fff',
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 30,
        },
        modalTitle: {
            fontSize: 19,
            color: '#03090E',
        },
        helpText: {
            color: 'red',
            padding: theme.spacing(0, 0, 0, 2)
        },
        dropdownIcon: {
            top: 4
        }
    }),
);

const ScheduleVehicleModal = (props: any) => {
    const classes = useStyles();
    const history = useHistory();
    const { open, onClose, transferId, fromTransfer,currentTripPlannerId,smaUser, locationId } = props;
    const [vehicleNo, setVehicleNo] = React.useState('');
    const [userList, setUserList] = React.useState('');
    const [isError, setIsError] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [vehicleNoList, setvehicleNoList] = React.useState<any[]>([]);
    const { handleSubmit, watch, formState, getValues, setError, control, setValue, errors, trigger } = useForm();

    const loadVehicles = async () => {
        let vehicleNumbers: String[] = [];
        let _currentTripPlannerId: any|null="";
        setIsLoading(true);
        if (currentTripPlannerId=="")
            _currentTripPlannerId=null;
        else
            _currentTripPlannerId=currentTripPlannerId;
        await api
            .getVehicles("", { fullNumber: true, tripPlannerId: _currentTripPlannerId, smaUser: smaUser, locationId: locationId!==undefined ? locationId:null,transferId: transferId !==""?transferId:null })
            .then((res) => {
                vehicleNumbers = res.model.map((v: any) => {
                    return String(v.text);
                });
            })
            .catch((error) => {
            });
        setvehicleNoList(vehicleNumbers);
        setIsLoading(false);
    }

    const assignVehicle = async (): Promise<void> => {
        setIsLoading(true);
        let values = getValues();

        let _req: { [index: string]: any } = {
            transferId: transferId,
            vehicle: values['vehicle'].toString(),
        };

        await api.assignVehicleToTransfer('', _req)
            .then(res => {
                if (!res.errorRaised) {
                    onClose();
                }
            })
            .catch(error => {

            });
        setIsLoading(false);
    }

    const loadNotifyPeople = async (vehicleNumber: any): Promise<void> => {
        await api.getNotifyingUsers('vehicle=' + vehicleNumber)
            .then(res => {
                if (!res.hasError) {
                    if (res.userList.length > 0)
                        setUserList(res.userList.toString());
                    else
                        setUserList('');
                }
            })
            .catch(error => {

            });
    }

    React.useEffect(() => {
        setUserList('');
        loadVehicles();
    }, []);

    React.useEffect(() => {
        setUserList('');
        loadVehicles();
    }, [currentTripPlannerId,transferId]);


    const onCloseLocal = () => {
        setUserList('');
        onClose();
    }

    return (
        <ThemeProvider theme={theme}>
            <Dialog classes={{ paper: classes.dialogPaper }} maxWidth="sm" open={open} onClose={onCloseLocal} aria-labelledby="form-dialog-title">
                <ThemeProvider theme={theme}>
                    <form onSubmit={handleSubmit(assignVehicle)}
                        autoComplete="off"
                        id="scheduleForm">

                        <DialogContent>
                            <div className={classes.header}>
                                <div className={classes.modalTitle}>Assign Transfer To Vehicle</div>
                                <ClearIcon onClick={onCloseLocal} style={{ cursor: "pointer", }} />
                            </div>
                            <Grid xs={12} item >
                                <Controller
                                    name='vehicle'
                                    defaultValue=''
                                    control={control}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <div>
                                            <Select
                                                key='Key'
                                                fullWidth={true}
                                                value={value}
                                                displayEmpty
                                                onChange={e => {
                                                    setVehicleNo(e.target.value + '');
                                                    setValue('vehicle', e.target.value);
                                                    if (e.target.value)
                                                        loadNotifyPeople(e.target.value);
                                                    onChange(e)
                                                }}
                                                IconComponent={KeyboardArrowDownIcon}
                                                classes={{icon:classes.dropdownIcon}}
                                                variant="outlined"
                                                defaultValue=''
                                                error={errors.vehicle}
                                                disabled={isLoading}>
                                                <MenuItem key="None" value={''}>{isLoading ? "Loading" :"Choose Vehicle" }</MenuItem >
                                                {
                                                    vehicleNoList.map((vehicleNo) => {
                                                        return (
                                                            <MenuItem key={vehicleNo} value={vehicleNo}>{vehicleNo}</MenuItem >
                                                        )
                                                    })
                                                }
                                            </Select>

                                        </div>
                                    )}
                                    rules={{
                                        required: "Vehicle is required",
                                        validate: (value) => {
                                            if (value == 'None' || value == '') {
                                                return false;
                                            }
                                            else {
                                                return true;
                                            }
                                        }
                                    }}
                                />
                                {
                                    (errors.vehicle) ?
                                        <FormHelperText className={classes.helpText}>
                                            Vehicle number is required
                                        </FormHelperText>
                                        : null
                                }
                            </Grid>

                            {
                                (!userList) ?
                                    null
                                    : <div style={{ margin: '30px 0px 10px 0px', color: '#000' }}>
                                        The following staff will be notified:<br /><b>{' ' + userList}</b>
                                    </div>
                            }


                        </DialogContent>

                        <DialogActions>
                            <Grid container spacing={3} style={{ marginBottom: 10 }}>
                                <Grid item xs={6}>
                                    <Button className={classes.button} onClick={onCloseLocal} style={{ fontWeight: 'bold', backgroundColor: '#ECECEC', color: '#090F15' }} color="primary">
                                        Cancel
                                </Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Button className={classes.button} disabled={formState.isSubmitting}
                                        type='submit' style={{ fontWeight: 'bold' }} color="primary">
                                        Assign
                                </Button>
                                </Grid>
                            </Grid>
                        </DialogActions>
                    </form>
                </ThemeProvider>
            </Dialog>
        </ThemeProvider>
    );
}


export default ScheduleVehicleModal;